const updates = [
  { date: '07-29', title: '《社内相亲》第128话更新，甜蜜大结局倒计时', tag: '热门' },
  { date: '07-29', title: '《我独自升级》番外篇连载开启，全新冒险篇章', tag: '新番' },
  { date: '07-28', title: '韩漫网新增30部校园题材韩漫免费漫画', tag: '上新' },
  { date: '07-28', title: '《全知读者视角》第215话关键剧情转折', tag: '热门' },
  { date: '07-27', title: '下拉式阅读功能优化，加载速度提升40%', tag: '公告' },
  { date: '07-27', title: '《女神降临》特别篇上线，读者好评如潮', tag: '推荐' },
  { date: '07-26', title: '悬疑韩漫专区上线，10部高口碑作品首发', tag: '上新' },
  { date: '07-26', title: '《恶役只有死亡结局》蝉联本周热度榜冠军', tag: '热榜' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          最新快讯
        </h2>
        <div className="space-y-3">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 md:gap-4 bg-background-100 rounded-lg p-3 md:p-4 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer"
            >
              <span className="text-xs font-mono text-foreground-400 whitespace-nowrap min-w-[44px]">
                {item.date}
              </span>
              <span className="flex-1 text-sm text-foreground-700 leading-relaxed">
                {item.title}
              </span>
              <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}